"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockSplash = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FFAB6F",
        d: "M21.333 3H2.667C1.194 3 0 3.895 0 5v14c0 1.105 1.194 2 2.667 2h18.666C22.806 21 24 20.105 24 19V5c0-1.105-1.194-2-2.667-2",
        className: styles.accentColor
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M6 16c0-.368.298-.667.667-.667h10.666a.667.667 0 0 1 0 1.334H6.667A.667.667 0 0 1 6 16",
        className: "no-layer-classgle",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "m10.368 11.287 2.965-3.954 4 5.334H6.667L9 9.333z" })
  );
};
export default BlockSplash;
